/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.AccountRoleRemovedResource = factory(root.GisServerApis.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The AccountRoleRemovedResource model module.
   * @module model/AccountRoleRemovedResource
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>AccountRoleRemovedResource</code>.
   * A resource of an account that removed from a role.
   * @alias module:model/AccountRoleRemovedResource
   * @class
   * @param accountId {String} The ID of the account that you want to remove from the role.
   * @param roleId {String} The ID of the role that the account removed from.
   */
  var exports = function(accountId, roleId) {
    var _this = this;

    _this['accountId'] = accountId;
    _this['roleId'] = roleId;
  };

  /**
   * Constructs a <code>AccountRoleRemovedResource</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AccountRoleRemovedResource} obj Optional instance to populate.
   * @return {module:model/AccountRoleRemovedResource} The populated <code>AccountRoleRemovedResource</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('accountId')) {
        obj['accountId'] = ApiClient.convertToType(data['accountId'], 'String');
      }
      if (data.hasOwnProperty('roleId')) {
        obj['roleId'] = ApiClient.convertToType(data['roleId'], 'String');
      }
    }
    return obj;
  }

  /**
   * The ID of the account that you want to remove from the role.
   * @member {String} accountId
   */
  exports.prototype['accountId'] = undefined;
  /**
   * The ID of the role that the account removed from.
   * @member {String} roleId
   */
  exports.prototype['roleId'] = undefined;



  return exports;
}));



